export enum BPMEventAction {
    select = 'select',
    deselect = 'deselect',
    openProperties = 'open properties',
    openRules = 'open rules',
    action = 'true'
}

export enum BPMEventTypes {
    status = 'status',
    path = 'path',
    mainActive = 'mainActive',
    bpmSaveDisabled = 'bpmSaveDisabled',
    bpmChartSaved = 'bpmChartSaved'
}

export type BPMEventDetails = {
    fromStatus: string | null;
    toStatus: string | null;
    isDisablePath?: boolean;
    action: BPMEventAction;
    type: BPMEventTypes;
};

export type BPMEvent = Event & {
    detail: {
        data: BPMEventDetails;
        type: 'change-BPM';
    };
};
